import { useRouter } from 'next/router'

import { useAuth } from '~/hooks/useAuth'

import { AuthContext } from './authenticationContext'

export const AuthContextWrapper = (props) => {
  const context = useAuth()

  const router = useRouter()

  const allowWhileNeeding2FA = ['/setup-2fa', '/sign-in', '/logout']

  if (
    context.authorizedValues.user &&
    context.authorizedValues.user.needs_2fa_setup &&
    !allowWhileNeeding2FA.includes(router.pathname)
  ) {
    return null // block render, redirect will fire elsewhere
  }

  return (
    <AuthContext.Provider value={context}>
      {props.children}
    </AuthContext.Provider>
  )
}

export default AuthContextWrapper
